import { FC, useEffect, useState }               from 'react';
import Style                                     from './Tabs.style';
import { TabsProps }                             from 'antd';
import { useParams }                             from 'react-router';
import { useLocation, useNavigate }              from 'react-router-dom';
import { argumentsToQuery, parseQueryArguments } from 'Utils';

type TProps = {
  defaultActiveKey?: string,
  queryArgument?: string,
  allowUrlHandling?: boolean,
  onChange?: (activeTab: string) => void,
  items: TabsProps['items']
};


export const Tabs: FC<TProps> = ({
  items,
  defaultActiveKey,
  queryArgument = 'tab',
  allowUrlHandling = true,
  onChange = () => {}
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params   = useParams();

  const { tab: _tab} = parseQueryArguments(window.location.search);

  const [activeTab, setActiveTab] = useState<string>(defaultActiveKey || _tab || '');

  const changeUrl = (activeTab: string) => {
    let queryArguments: Record<string, string> = {};
    if(location.search) {
      queryArguments = parseQueryArguments(location.search);
    }
    if(!allowUrlHandling || queryArguments[queryArgument] === activeTab) {
      return;
    }

    queryArguments[queryArgument] = activeTab;
    navigate(`${location.pathname}?${argumentsToQuery(queryArguments)}`, { replace: true });
  };

  useEffect(() => {
    let activeTab = defaultActiveKey;
    if(allowUrlHandling && params[queryArgument]) {
      activeTab = params[queryArgument];
    }
    if(allowUrlHandling && location.search) {
      const queryArguments = parseQueryArguments(location.search);
      if(queryArguments[queryArgument]) {
        activeTab = queryArguments[queryArgument];
      }
    }
    if(!activeTab) {
      activeTab = items?.[0]?.key || '';
    }
    setActiveTab(activeTab || '');
    changeUrl(activeTab);
  }, []);

  const handleOnChangeTab = (activeTab: string) => {
    setActiveTab(activeTab);
    onChange(activeTab);
    changeUrl(activeTab);
  }

  return (
    <Style items={items} defaultActiveKey={defaultActiveKey} onChange={handleOnChangeTab} activeKey={activeTab} />
  );
}

